export default "__VITE_ASSET__a26dac87__"